<template>
  <card class="custom-shadow-card-header">
    <div class="font-weight-bold mb-4 mt-2">
      <h5 class="title">
        {{ $t('vie.Pag.Das.Bus.Use.EditProfileForm.userProfile') }}
      </h5>
    </div>
    <div>
      <form>
        <h5>
          {{ $t('vie.Pag.Das.Bus.Use.EditProfileForm.generalInformation') }}
        </h5>
        <hr />
        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              :label="$t('common_words.username')"
              :disabled="true"
              v-model="user.username"
            >
            </fg-input>
          </div>
          <div class="col-md-6">
            <label>&nbsp;</label><br />
            <button
              type="button"
              class="btn btn-secondary btn-fill btn-md"
              @click.prevent="openModal"
            >
              {{ $t('vie.Pag.Das.Bus.Use.EditProfileForm.changePassword') }}
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              :label="$t('common_words.names')"
              v-model="user.first_name"
            >
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input
              type="text"
              :label="$t('common_words.surnames')"
              v-model="user.last_name"
            >
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              :label="$t('common_words.email')"
              v-model="user.email"
              disabled
            >
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input
              type="text"
              :label="$t('vie.Pag.Das.Bus.Use.EditProfileForm.downTime')"
              v-model="user.downtime"
            >
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <fg-input :label="$t('common_words.description')">
              <textarea
                v-model="user.description"
                class="form-control"
                rows="3"
              >
              </textarea>
            </fg-input>
          </div>
        </div>
        <h5>
          {{ $t('vie.Pag.Das.Bus.Use.EditProfileForm.profileInformation') }}
        </h5>
        <hr />
        <div class="row">
          <div class="col-md-4">
            <fg-input
              type="text"
              :label="$t('common_words.profile')"
              v-model="capitalizeRole"
              disabled
            >
            </fg-input>
          </div>
          <div class="col-md-5">
            <label>{{ $t('common_words.companies') }}</label>
            <el-select
              disabled
              multiple
              collapse-tags
              class="select-primary custom-width-select bus-rels shadow-sm"
              v-model="user.businesses"
            >
              <el-option
                class="select-default"
                v-for="item in user.businesses"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col 3">
            <button
              type="button"
              class="btn btn-secondary btn-fill btn-md"
              style="margin-top: 36px"
              @click.prevent="openPolice"
            >
              {{ $t('vie.Pag.Das.Bus.Use.EditProfileForm.viewLicense') }}
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label>{{ $t('common_words.permissions') }}</label>
            <br />
            <template v-for="(permission, index) in user.permissions">
              <el-tag
                :key="index"
                size="small"
                type="info"
                :closable="false"
                :close-transition="false"
              >
                {{ permission }}
              </el-tag>
            </template>
          </div>
        </div>
        <br />

        <hr />
        <div class="text-center">
          <button
            type="submit"
            class="btn btn-info btn-fill btn-wd"
            @click.prevent="updateProfile"
          >
            {{ $t('vie.Pag.Das.Bus.Use.EditProfileForm.updateProfile') }}
          </button>
        </div>

        <div class="clearfix"></div>
      </form>
    </div>
    <div class="row">
      <div class="col-12">
        <el-dialog
          width="80%"
          class="custom-dialog"
          :close-on-click-modal="false"
          :title="$t('vie.Pag.Das.Bus.Use.EditProfileForm.changePassword')"
          @close="resetModels()"
          :visible.sync="modals.change_password"
        >
          <div class="text-center">
            <div class="row">
              <div class="col-4">
                <card class="card-policies">
                  <div class="d-flex flex-column align-items-start">
                    <div id="rr" class="custom-control pl-0 float-left mb-1">
                      <l-switch
                        v-bind:value="
                          /[A-Z]/.test(this.user_password.new_password)
                            ? true
                            : false
                        "
                        color="green"
                      >
                        <em class="fa fa-check" slot="on"></em>
                        <em class="fa fa-times" slot="off"></em>
                      </l-switch>
                      {{
                        $t(
                          'vie.Pag.Das.Bus.Use.EditProfileForm.minimumOneCapitalLetter'
                        )
                      }}
                    </div>
                    <div class="custom-control pl-0 float-left mb-1">
                      <l-switch
                        v-bind:value="
                          /[a-z]/.test(this.user_password.new_password)
                            ? true
                            : false
                        "
                        color="green"
                      >
                        <em class="fa fa-check" slot="on"></em>
                        <em class="fa fa-times" slot="off"></em>
                      </l-switch>
                      {{
                        $t(
                          'vie.Pag.Das.Bus.Use.EditProfileForm.minimumOneLowercase'
                        )
                      }}
                    </div>
                    <div class="custom-control pl-0 float-left mb-1">
                      <l-switch
                        v-bind:value="
                          /[0-9]/.test(this.user_password.new_password)
                            ? true
                            : false
                        "
                        color="green"
                      >
                        <em class="fa fa-check" slot="on"></em>
                        <em class="fa fa-times" slot="off"></em>
                      </l-switch>
                      {{
                        $t(
                          'vie.Pag.Das.Bus.Use.EditProfileForm.atLeastOneNumber'
                        )
                      }}
                    </div>
                    <div class="custom-control pl-0 float-left mb-1">
                      <l-switch
                        v-bind:value="
                          this.user_password.new_password.length > 7
                            ? true
                            : false
                        "
                        color="green"
                      >
                        <em class="fa fa-check" slot="on"></em>
                        <em class="fa fa-times" slot="off"></em>
                      </l-switch>
                      {{
                        $t(
                          'vie.Pag.Das.Bus.Use.EditProfileForm.minimum8Characters'
                        )
                      }}
                    </div>
                    <div class="custom-control pl-0 float-left mb-1">
                      <l-switch
                        v-bind:value="
                          /[.:,;<>¿¡=#@$!%\*\+\-\}\{\)\(\/|\_?&]/.test(
                            this.user_password.new_password
                          )
                            ? true
                            : false
                        "
                        color="green"
                      >
                        <em class="fa fa-check" slot="on"></em>
                        <em class="fa fa-times" slot="off"></em>
                      </l-switch>
                      {{
                        $t(
                          'vie.Pag.Das.Bus.Use.EditProfileForm.atLeastOneSpecialCharacter'
                        )
                      }}
                    </div>
                    <div class="custom-control pl-0 float-left mb-1">
                      <l-switch
                        v-bind:value="
                          this.user_password.new_password ==
                            this.user_password.new_password_confirmation &&
                          this.user_password.new_password.length > 7
                            ? true
                            : false
                        "
                        color="green"
                      >
                        <em class="fa fa-check" slot="on"></em>
                        <em class="fa fa-times" slot="off"></em>
                      </l-switch>
                      {{
                        $t('vie.Pag.Das.Bus.Use.EditProfileForm.mustBeTheSame')
                      }}
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-4">
                <form>
                  <div class="row">
                    <div class="col-12 pt-0 text-left">
                      <p class="text-muted">
                        {{
                          $t('vie.Pag.Das.Bus.Use.EditProfileForm.fillThisInfo')
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 pt-0">
                      <fg-input
                        :placeholder="
                          $t(
                            'vie.Pag.Das.Bus.Use.EditProfileForm.currentPassword'
                          )
                        "
                        v-model="user_password.old_password"
                        v-validate="modelValidations.old_password"
                        name="common_words.current_password"
                        :error="getError('common_words.current_password', true)"
                        :type="showPass.inputTypePass"
                        :myCustom="{ addon: 'not-input-group-addon' }"
                        @change="showHideErrorPassword()"
                        @keydown.native="showHideErrorPassword()"
                      >
                        <template slot="addonRight">
                          <l-button @click="showPassword(1)">
                            <em :class="showPass.iconBtnPass"></em>
                          </l-button>
                        </template>
                      </fg-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <fg-input
                        :placeholder="
                          $t('vie.Pag.Das.Bus.Use.EditProfileForm.newPassword')
                        "
                        v-model="user_password.new_password"
                        v-validate="modelValidations.new_password"
                        ref="new_password"
                        name="common_words.new_password"
                        :error="getError('common_words.new_password', true)"
                        :type="showPass.inputTypePass2"
                        :myCustom="{ addon: 'not-input-group-addon' }"
                        @change="showHideErrorPassword()"
                        @keydown.native="showHideErrorPassword()"
                      >
                        <template slot="addonRight">
                          <l-button @click="showPassword(2)">
                            <em :class="showPass.iconBtnPass2"></em>
                          </l-button>
                        </template>
                      </fg-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <fg-input
                        :placeholder="
                          $t(
                            'vie.Pag.Das.Bus.Use.EditProfileForm.confirmNewPassword'
                          )
                        "
                        v-model="user_password.new_password_confirmation"
                        v-validate="modelValidations.new_password_confirmation"
                        name="common_words.confirm_new_password"
                        :error="
                          getError('common_words.confirm_new_password', true)
                        "
                        :type="showPass.inputTypePass2"
                        :myCustom="{ addon: 'not-input-group-addon' }"
                        @change="showHideErrorPassword()"
                        @keydown.native="showHideErrorPassword()"
                      >
                        <template slot="addonRight">
                          <l-button @click="showPassword(2)">
                            <em :class="showPass.iconBtnPass2"></em>
                          </l-button>
                        </template>
                      </fg-input>
                    </div>
                  </div>
                  <div class="row" v-show="errorAlert">
                    <div class="col-lg-12">
                      <br />
                      <el-alert
                        v-show="errorAlert"
                        ref="error_alert"
                        :title="$t('common_words.errors')"
                        type="error"
                        class="text-left"
                        @close="errorAlert = false"
                        >a</el-alert
                      >
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-4">
                <card class="card-policies">
                  <div slot="header">
                    <h5 class="card-title text-left">
                      {{
                        $t('vie.Pag.Das.Bus.Use.EditProfileForm.otherPolicies')
                      }}
                    </h5>
                  </div>
                  <div>
                    <ul class="pl-4">
                      <li class="text-justify break-word">
                        {{
                          $t(
                            'vie.Pag.Das.Bus.Use.EditProfileForm.otherPoliciesText1'
                          )
                        }}
                      </li>
                      <li class="text-justify break-word">
                        {{
                          $t(
                            'vie.Pag.Das.Bus.Use.EditProfileForm.otherPoliciesText2'
                          )
                        }}
                      </li>
                      <li class="text-justify break-word">
                        {{
                          $t(
                            'vie.Pag.Das.Bus.Use.EditProfileForm.otherPoliciesText3'
                          )
                        }}
                      </li>
                      <li class="text-justify break-word">
                        {{
                          $t(
                            'vie.Pag.Das.Bus.Use.EditProfileForm.otherPoliciesText4'
                          )
                        }}
                      </li>
                    </ul>
                  </div>
                </card>
              </div>
            </div>
          </div>
          <hr class="m-0" />
          <span slot="footer" class="dialog-footer custom-dialog-footer">
            <button class="btn btn-secondary" @click="closeModal">
              {{ $t('common_words.cancel') }}</button
            >&nbsp;
            <button class="btn btn-success" @click="validateSubmit">
              {{ $t('common_words.confirm') }}
            </button>
          </span>
        </el-dialog>
      </div>
    </div>
    <app-politics v-model="AppPolitics" :policy="policy" :showButton="false" />
  </card>
</template>
<script>
import { Switch as LSwitch } from 'src/components/index';
import { mapGetters } from 'vuex';
import { Alert } from 'element-ui';
import SweetAlert from 'src/class/Alerts';
import axios from 'axios';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import MixinForm from 'src/mixins/forms/mixin-form';
import AppPolitics from 'src/views/Pages/Auth/AppPolitics.vue';
import i18n from '../../../../i18n';

export default {
  components: {
    [Alert.name]: Alert,
    LSwitch,
    AppPolitics,
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      userdata: 'auth/user',
    }),
    capitalizeRole() {
      return this.user.roles[0].name
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    policyUrl() {
      if (this.policy) {
        return this.policy.url;
      }
      return '';
    },
  },
  data() {
    return {
      user: {
        first_name: null,
        last_name: null,
        username: null,
        email: null,
        temporary_password: null,
        roles: null,
        role_id: null,
        departments: null,
        department_id: null,
        permissions: null,
        description: null,
        downtime: null,
        businesses: [],
      },
      model: {
        description: null,
      },
      user_password: {
        username: null,
        old_password: '',
        new_password: '',
        new_password_confirmation: '',
      },
      modals: {
        change_password: false,
      },
      modelValidations: {
        old_password: {
          required: true,
          min: 8,
        },
        new_password: {
          required: true,
          min: 8,
        },
        new_password_confirmation: {
          required: true,
          confirmed: 'new_password',
          min: 8,
        },
      },
      showPass: {
        inputTypePass: 'password',
        inputTypePass2: 'password',
        iconBtnPass: 'fa fa-eye',
        iconBtnPass2: 'fa fa-eye',
      },
      validateForm: false,
      errorAlert: null,
      AppPolitics: false,
      policy: null,
    };
  },
  mixins: [MixinForm, MixinNotification],
  methods: {
    openModal() {
      this.modals.change_password = true;
    },
    openPolice() {
      this.AppPolitics = true;
    },

    closeModal() {
      this.modals.change_password = false;
      this.AppPolitics = false;
      this.resetModels();
    },

    showPassword(input_num) {
      if (input_num == '1') {
        if (this.showPass.inputTypePass === 'password') {
          this.showPass.iconBtnPass = 'fa fa-eye-slash';
          this.showPass.inputTypePass = 'text';
        } else {
          this.showPass.iconBtnPass = 'fa fa-eye';
          this.showPass.inputTypePass = 'password';
        }
      } else {
        if (this.showPass.inputTypePass2 === 'password') {
          this.showPass.iconBtnPass2 = 'fa fa-eye-slash';
          this.showPass.inputTypePass2 = 'text';
        } else {
          this.showPass.iconBtnPass2 = 'fa fa-eye';
          this.showPass.inputTypePass2 = 'password';
        }
      }
    },

    validateSubmit() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          //$t('vie.Pag.Das.Bus.Use.EditProfileForm.errorText1');
          let errorAlertTitle =
            i18n.t('vie.Pag.Das.Bus.Use.EditProfileForm.errorText1') + '<br>';
          this.$refs.error_alert.$el.children[0].children[1].innerHTML = ``;
          this.validateForm = true;

          if (!/[A-Z]/.test(this.user_password.new_password)) {
            this.errorAlert = true;
            this.validateForm = false;
            errorAlertTitle +=
              i18n.t('vie.Pag.Das.Bus.Use.EditProfileForm.errorPassText1') +
              `<br>`;
          }

          if (!/[a-z]/.test(this.user_password.new_password)) {
            this.errorAlert = true;
            this.validateForm = false;
            errorAlertTitle +=
              i18n.t('vie.Pag.Das.Bus.Use.EditProfileForm.errorPassText2') +
              `<br>`;
          }

          if (!/[0-9]/.test(this.user_password.new_password)) {
            this.errorAlert = true;
            this.validateForm = false;
            errorAlertTitle +=
              i18n.t('vie.Pag.Das.Bus.Use.EditProfileForm.errorPassText3') +
              `<br>`;
          }

          if (
            !/[.:,;<>¿¡=#@$!%\*\+\-\}\{\)\(\/|\_?&]/.test(
              this.user_password.new_password
            )
          ) {
            this.errorAlert = true;
            this.validateForm = false;
            errorAlertTitle +=
              i18n.t('vie.Pag.Das.Bus.Use.EditProfileForm.errorPassText4') +
              `<br>`;
          }

          this.$refs.error_alert.$el.children[0].children[1].innerHTML =
            errorAlertTitle;

          if (this.validateForm) {
            this.$refs.error_alert.$el.children[0].children[1].innerHTML = '';
            this.changePassword();
          }
        }
      });
    },

    showHideErrorPassword() {
      this.$refs.error_alert.$el.children[0].children[1].innerHTML = '';
      this.errorAlert = false;
    },

    resetModels() {
      this.user_password = {
        username: null,
        old_password: '',
        new_password: '',
        new_password_confirmation: '',
      };

      this.$validator.reset();

      this.showPass = {
        inputTypePass: 'password',
        inputTypePass2: 'password',
        iconBtnPass: 'fa fa-eye',
        iconBtnPass2: 'fa fa-eye',
      };

      this.validateForm = false;
      this.errorAlert = false;
      this.$refs.error_alert.$el.children[0].children[1].innerHTML = '';
    },

    updateProfile() {
      SweetAlert.default(
        i18n.t('vie.Pag.Das.Bus.Use.EditProfileForm.updateUserProfile'),
        i18n.t('vie.Pag.Das.Bus.Use.EditProfileForm.confirmUpdateProfile'),
        i18n.t('common_words.confirm'),
        0
      ).then((result) => {
        if (result.value) {
          this.$emit('isLoading', true);
          axios
            .post('/auth/users/profile', this.user)
            .then((response) => {
              this.showNotification(
                `${response.data.message}`,
                'success',
                'nc-settings-tool-66',
                i18n.t('common_words.success_operation') + '...'
              );
              this.$emit('isLoading', false);
            })
            .catch((error) => {
              this.showNotification(
                `${error.response.data.message}`,
                'danger',
                'nc-simple-remove',
                i18n.t('common_words.alert') + '...'
              );
              this.$emit('isLoading', false);
            });
        }
      });
    },

    changePassword() {
      this.$emit('isLoading', true);
      this.user_password.username = this.user.username;
      axios
        .post('/auth/users/password', this.user_password)
        .then((response) => {
          this.closeModal();
          this.showNotification(
            i18n.t(
              'vie.Pag.Das.Bus.Use.EditProfileForm.passUpdatedSuccessfully'
            ),
            'success',
            'nc-key-25',
            i18n.t('common_words.success_operation') + '...'
          );
          this.$emit('isLoading', false);
          this.resetModels();
        })
        .catch((error) => {
          this.errorAlert = error.response.data.message;
          this.$refs.error_alert.$el.children[0].children[1].innerHTML =
            error.response.data.message;
          /* this.showNotification(
            `${error.response.data.message}`,
            "danger",
            "nc-simple-remove",
            "Alerta..."
          ); */
          this.$emit('isLoading', false);
        });
    },
  },

  created() {
    axios
      .get('policyversions/index')
      .then((response) => {
        if (response.data.data) {
          this.policy = response.data.data[0];
        }
      })
      .catch((error) => {
        SweetAlert.warning(error.response.data.message);
      });
    this.user.businesses = this.$store.state.auth.user.business.sort(
      (a, b) => b.id - a.id
    );
    this.user.first_name = this.userdata.first_name;
    this.user.last_name = this.userdata.last_name;
    this.user.username = this.userdata.username;
    this.user.email = this.userdata.email;
    this.user.roles = this.userdata.roles;
    this.user.description = this.userdata.description;
    this.user.downtime = this.userdata.downtime;
    this.user.permissions = this.userdata.permissions;

    if (this.user.roles[0].permissions) {
      this.user.permissions = this.user.permissions.concat(
        this.user.roles[0].permissions
      );
    }

    this.user.permissions = [
      ...new Set(
        this.user.permissions.map(function (item) {
          if (
            item.name != undefined &&
            !item.name.includes('.index') &&
            !item.name.includes('.store') &&
            !item.name.includes('.update') &&
            !item.name.includes('.destroy')
          ) {
            return item.name;
          }
        })
      ),
    ];

    setTimeout(() => {
      this.user.permissions.forEach((element, index) => {
        if (element == undefined) {
          this.user.permissions.splice(index, 1);
        }
      });
    }, 100);

    if (this.userdata.department) {
      this.user.department_label = this.userdata.department.department;
    } else {
      this.user.department_label = '';
    }
  },
};
</script>
<style>
.card-policies > .card-body {
  padding: 15px;
}
</style>
